import { render, staticRenderFns } from "./CvTable.vue?vue&type=template&id=5e788c4f&scoped=true"
import script from "./CvTable.vue?vue&type=script&lang=js"
export * from "./CvTable.vue?vue&type=script&lang=js"
import style0 from "./CvTable.vue?vue&type=style&index=0&id=5e788c4f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e788c4f",
  null
  
)

export default component.exports